export default __webpack_public_path__ + "static/media/misc-books5-1440w.6a8efe4d.webp";